import { IPersonData } from '@th-types/person.type';
import { IWorkerData } from '@th-types/worker.type';
import { ITag, IN_NETWORK_TAG } from '@th-types/tag.type';

export const getPersonByWorker = (personId: number, worker: IWorkerData) => {
  const result: IPersonData = {
    id: personId,
    address: worker.address,
    cellPhone: worker.cellPhone,
    email: worker.email,
    firstName: worker.firstName,
    lastName: worker.lastName,
    fullName: `${worker.firstName} ${worker.lastName}`,
    profileImageUrl: worker.profileImageUrl,
  };
  return result;
};

export const containsInNetworkBadge = (worker: IWorkerData): boolean => {
  return (
    !!worker?.features?.find((f) => f.feature === 'IN_NETWORK_BADGE') ||
    worker.isPremium
  );
};

export const getWorkerTags = (
  worker: IWorkerData,
  matchSkills: boolean = false
): ITag[] => {
  const tags: ITag[] = [];

  if (containsInNetworkBadge(worker)) {
    tags.push(IN_NETWORK_TAG);
  }

  if (matchSkills) {
    tags.push({
      label: 'MATCH',
      bg: 'light-success',
      bgText: 'text-success',
      className: 'cursor-default',
    });
  }

  return tags;
};
